import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWallet5"><Path d="M22 4V8.5H14.5V15.5H22V20H2V4H22Z" fill="currentColor"/><Path d="M16 10H23V14H16V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWallet5;
